import React from 'react';

import { SubHeading } from 'reaxl';
import {
    OwnerWebsiteCTA,
} from 'reaxl-molecules';

function DealerTitle({ analyticsData, isLink, href, componentClass, children, ...rest }) {
    if (!href) {
        isLink = false;
    }

    return (isLink ? (
        <OwnerWebsiteCTA
            label={(
                <SubHeading
                    size={400}
                    className="display-inline"
                    componentClass={componentClass}
                >
                    {children}
                </SubHeading>
            )}
            href={href}
            uiContext="unstyledLink"
            analyticsData={analyticsData}
            {...rest}
        />
    ) : (
        <SubHeading
            size={400}
            componentClass={componentClass}
            {...rest}
        >
            {children}
        </SubHeading>
    ));
}

export default DealerTitle;
